export const CATEGORY_LABELS = {
	faq_readiness: "FAQ readiness",
	schema: "Schema markup",
	answerability: "Answer formatting",
	technical: "Technical signals",
	readability: "Content readability",
	content_depth: "Content depth",
	internal_linking: "Internal linking",
	e_clarity: "Product clarity",
	multimodal: "Multimodal signals",
	crawlability: "Crawlability",
	metadata: "Metadata quality",
	brand_entity: "Brand entity",
	ai_citation: "AI Citation",
	ai_discoverability: "AI discoverability",
	trust_signals: "Trust & authority",
	freshness: "Content freshness",
	sentiment: "AI sentiment",
	brand_recognition: "Brand recognition",
	eeat: "E-E-A-T",
	llms_txt: "LLMs.txt",
	experience: "Experience",
	expertise: "Expertise",
};

export function formatCategoryLabel(category) {
	if (!category) return "";
	if (CATEGORY_LABELS[category]) return CATEGORY_LABELS[category];
	return String(category).replace(/_/g, " ");
}
